import { DateTime } from 'luxon';

/**
 * Format ISO timestamp for settings tables: "Feb 15, 2026 at 10:30 AM"
 */
export const formatTimestamp = (isoTimestamp: string | null | undefined): string => {
    if (!isoTimestamp) return '—';
    const dt = DateTime.fromISO(isoTimestamp);
    if (!dt.isValid) return '—';
    return dt.toFormat("MMM d, yyyy 'at' h:mm a");
};
